import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/features/domru-bonus/styled';

export const CardWrapper = styled.div`
    width: 433px;
    padding: 32px 40px 28px;
    border-radius: 16px;
    background-color: ${COLORS.white};

    @media (max-width: ${breakPoints.sDesktop}) {
        width: 328px;
        height: 100%;
        padding: 32px 20px 20px 40px;
    }

    @media (max-width: ${breakPoints.laptop}) {
        width: auto;
        min-width: 256px;
        max-width: 100%;
        margin-right: 16px;
        padding: 24px 16px 18px 20px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        width: auto;
        min-width: 272px;
        max-width: 100%;
        margin-right: 12px;
        padding: 24px 12px 24px 20px;
    }
`;

export const CardTitle = styled.p`
    ${FONTS.S};
    margin-bottom: 12px;
    white-space: pre-wrap;

    @media (max-width: ${breakPoints.laptop}) {
        ${FONTS.XS};
    }

    @media (max-width: ${breakPoints.tablet}) {
        ${FONTS.S};
    }
`;

export const CardDescription = styled.p`
    ${FONTS.M};
    white-space: pre-wrap;

    @media (max-width: ${breakPoints.laptop}) {
        ${FONTS.XS};
    }

    @media (max-width: ${breakPoints.tablet}) {
        ${FONTS.M};
    }
`;

export const CardLink = styled.a`
    ${FONTS.MediumS};
    color: ${COLORS.blue};
    margin-top: 6px;

    &:focus,
    &:visited {
        color: ${COLORS.blue};
    }
`;
